module.exports = __webpack_public_path__ + "static/media/projector.7fdd9ddf.svg";